export default {
  path: '/statement',
  component: () => import('@/views/stateMent/statement-router.vue'),
  children: [
    {
      path: '',
      name: 'TreatmentReport',
      component: () => import('@/views/stateMent/pages/TreatmentReport.vue'),
      meta: {
        name: 'navigationDrawer.treatmentReport',
        icon: '/icons/statement.svg',
        auth: true
      }
    },
    {
      path: 'receivedReport',
      name: 'ReceivedReport',
      component: () => import('@/views/stateMent/pages/ReceivedReport.vue'),
      meta: {
        name: 'navigationDrawer.treatmentReport',
        icon: '/icons/statement.svg',
        auth: true
      }
    },
    {
      path: 'ingredientReport',
      name: 'IngredientReport',
      component: () => import('@/views/stateMent/pages/IngredientReport.vue'),
      meta: {
        name: 'navigationDrawer.treatmentReport',
        icon: '/icons/statement.svg',
        auth: true
      }
    },
    {
      path: 'productReport',
      name: 'ProductReport',
      component: () => import('@/views/stateMent/pages/ProductReport.vue'),
      meta: {
        name: 'navigationDrawer.treatmentReport',
        icon: '/icons/statement.svg',
        auth: true
      }
    },
    {
      path: 'courseReport',
      name: 'CourseReport',
      component: () => import('@/views/stateMent/pages/CourseReport.vue'),
      meta: {
        name: 'navigationDrawer.treatmentReport',
        icon: '/icons/statement.svg',
        auth: true
      }
    },
    {
      path: 'physicianIncomeReport',
      name: 'PhysicianIncomeReport',
      component: () => import('@/views/stateMent/pages/PhysicianIncomeReport.vue'),
      meta: {
        name: 'navigationDrawer.treatmentReport',
        icon: '/icons/statement.svg',
        auth: true
      }
    }
  ]
}
